import React from "react";
import { ShieldCheck } from "lucide-react";
import UlendoWordmark from "../components/branding/UlendoWordmark";

export default function SplashScreen() {
  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-[var(--ulendo-haze)] text-[var(--ulendo-charcoal)]">
      <div
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top,_rgba(14,91,42,0.14),transparent_62%)]"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none absolute -bottom-32 -right-24 h-[70vh] w-[70vh] rounded-full bg-[radial-gradient(circle,_rgba(249,185,52,0.28),transparent_70%)] blur-3xl"
        aria-hidden="true"
      />

      <div className="relative z-10 mx-auto flex w-full max-w-3xl flex-col items-center gap-10 px-6 text-center">
        <div className="flex flex-col items-center gap-6">
          <UlendoWordmark size={60} />
          <span className="inline-flex h-16 w-16 items-center justify-center rounded-3xl border border-[rgba(14,91,42,0.18)] bg-white/90 shadow-[0_14px_30px_rgba(14,91,42,0.12)]">
            <ShieldCheck className="h-8 w-8 text-[var(--ulendo-forest)]" aria-hidden="true" />
          </span>

          <div className="space-y-2">
            <p className="text-xs font-semibold uppercase tracking-[0.42em] text-[var(--ulendo-text-muted)]">
              Ulendo Platform
            </p>
            <h1 className="text-3xl font-semibold text-[var(--ulendo-forest-dark)] sm:text-4xl">Loading Workspace</h1>
            <p className="mx-auto max-w-xl text-sm text-[var(--ulendo-text-muted)]">
              Preparing your personalised Ulendo environment and restoring the latest operational data snapshots.
              Secure session initialisation is in progress.
            </p>
          </div>
        </div>

        <div className="flex flex-col items-center gap-4">
          <div className="relative h-14 w-14">
            <div className="absolute inset-0 rounded-full border-2 border-[rgba(14,91,42,0.2)]" aria-hidden="true" />
            <div className="absolute inset-0 rounded-full border-2 border-t-transparent border-[var(--ulendo-forest)] animate-spin" aria-hidden="true" />
          </div>
          <p className="text-xs font-medium uppercase tracking-[0.32em] text-[var(--ulendo-text-muted)]">
            Preparing secure session
          </p>
        </div>

        <div className="w-full max-w-md space-y-2 text-xs text-[var(--ulendo-text-muted)]">
          <div className="h-1.5 w-full overflow-hidden rounded-full bg-[rgba(14,91,42,0.12)]">
            <div className="h-full w-1/2 animate-[pulse_2.8s_ease-in-out_infinite] rounded-full bg-[var(--ulendo-forest)]/80" />
          </div>
          <p>Ulendo • Secure analytics and operations suite</p>
        </div>
      </div>
    </div>
  );
}
